import { useState, useEffect } from 'react';

function useTypekitReady() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready) {
      document.documentElement.classList.add("typekitReady");
      return;
    }
    document.fonts.ready.then(() => {
      document.documentElement.classList.add("typekitReady");
      setReady(true);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return ready;
}

export { useTypekitReady };
//# sourceMappingURL=useTypekitReady.js.map
